var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveBooking && _vm.havePaymentViewing && _vm.canShowPayments
    ? _c(
        "div",
        [
          _vm.paymentViewingIsPaid || _vm.paymentViewingIsOnHold
            ? _c("payment-single-success", {
                attrs: { "payment-viewing": _vm.paymentViewing },
              })
            : [
                _c("div", { staticClass: "dashboard-page-title" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container-fluid",
                      staticStyle: { "max-width": "630px" },
                    },
                    [
                      _c(
                        "h1",
                        {
                          staticClass: "text-center",
                          staticStyle: { "margin-top": "50px" },
                        },
                        [_vm._v("Complete Payment")]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "dashboard-block" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8",
                        },
                        [
                          _c("div", { staticClass: "payment-container" }, [
                            _c(
                              "div",
                              { staticClass: "text-center payment-alert" },
                              [
                                this.bookingPaymentRequiresBoth ||
                                this.bookingPaymentDepositIsUnpaid
                                  ? _c("div", { staticClass: "h4" }, [
                                      _c("p", [
                                        _vm._v(
                                          "Thanks for booking a sports " +
                                            _vm._s(_vm.$starLabel) +
                                            "!"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "To confirm your booking, please pay your deposit as soon as possible."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        [
                                          _vm._v(
                                            "Or review your\n                      "
                                          ),
                                          _c(
                                            "router-link",
                                            {
                                              staticStyle: {
                                                "text-decoration": "underline",
                                              },
                                              attrs: {
                                                "active-class": "",
                                                to: {
                                                  name: "bookings.show",
                                                  params: {
                                                    id: this.bookingId,
                                                  },
                                                },
                                              },
                                            },
                                            [_c("a", [_vm._v("booking")])]
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _c("div", { staticClass: "h4" }, [
                                      _c("p", [_vm._v("You're almost there!")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Please pay the outstanding amount to finalise your booking."
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        [
                                          _vm._v(
                                            "Or review your\n                    "
                                          ),
                                          _c(
                                            "router-link",
                                            {
                                              staticStyle: {
                                                "text-decoration": "underline",
                                              },
                                              attrs: {
                                                "active-class": "",
                                                to: {
                                                  name: "bookings.show",
                                                  params: {
                                                    id: this.bookingId,
                                                  },
                                                },
                                              },
                                            },
                                            [_c("a", [_vm._v("booking")])]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-horizontal" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "form-group payment-details" },
                                  [
                                    _c("div", { staticClass: "col-sm-4" }, [
                                      _c(
                                        "p",
                                        { staticClass: "control-label" },
                                        [_vm._v("Payment")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-sm-8" }, [
                                      _c("p", { staticClass: "detail" }, [
                                        _vm._v(
                                          "Booking #" +
                                            _vm._s(
                                              _vm._f("padded")(
                                                _vm.booking.id,
                                                "0",
                                                5
                                              )
                                            )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "clearfix m-b-sm",
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-sm-4" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "control-label label-amount",
                                        },
                                        [_vm._v("Amount")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-8" },
                                      [
                                        _c("selectize", {
                                          staticClass:
                                            "selectize selectize-single form-control",
                                          attrs: {
                                            name: "payment_amount",
                                            "disable-delete": true,
                                            options: _vm.paymentAmountOptions,
                                          },
                                          model: {
                                            value: _vm.statePaymentIds,
                                            callback: function ($$v) {
                                              _vm.statePaymentIds = $$v
                                            },
                                            expression: "statePaymentIds",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    this.bookingPaymentRequiresBoth
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "text-danger" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-info-circle",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                                _vm._v(
                                                  "  As your booking is less than 14 days away, we require full payment"
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "decorative-divider",
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "form-group",
                                      _vm.errorClass("payment_method"),
                                    ],
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "col-sm-4 control-label",
                                        attrs: { for: "payment-method" },
                                      },
                                      [_vm._v("Payment Method")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-8" },
                                      [
                                        _c("selectize", {
                                          staticClass:
                                            "selectize selectize-single form-control",
                                          attrs: {
                                            id: "payment-method",
                                            name: "payment_method",
                                            "disable-delete": true,
                                            options:
                                              _vm.enabledPaymentMethodOptions,
                                          },
                                          model: {
                                            value: _vm.paymentMethod,
                                            callback: function ($$v) {
                                              _vm.paymentMethod = $$v
                                            },
                                            expression: "paymentMethod",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("help-block", {
                                          attrs: { field: "payment_method" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.paymentMethodIsCreditCard
                                  ? _c("payment-single-credit-card", {
                                      attrs: {
                                        "payment-ids": _vm.paymentIds,
                                        "payment-amount": _vm.paymentAmount,
                                        "card-surcharge": _vm.cardSurcharge,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.paymentMethodIsBankTransfer
                                  ? _c("payment-single-bank-transfer", {
                                      attrs: { "payment-ids": _vm.paymentIds },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.paymentMethodIsCheque
                                  ? _c("payment-single-cheque", {
                                      attrs: { "payment-ids": _vm.paymentIds },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.paymentMethodIsExistingCreditCard
                                  ? _c("payment-single-existing-credit-card", {
                                      attrs: {
                                        "payment-ids": _vm.paymentIds,
                                        "payment-amount": _vm.paymentAmount,
                                        "card-surcharge": _vm.cardSurcharge,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }